<header class="toolbar" #headerRef>
  <div class="toolbar__menu">
    <button
      class="toolbar__menu__hamburger hamburger hamburger--elastic-r"
      [class.is-active]="isActiveMenu"
      type="button"
      aria-label="Menu"
      aria-controls="navigation"
      (click)="toggleMenu()"
    >
      <span class="hamburger-box">
        <span class="hamburger-inner"></span>
      </span>
    </button>
    <a class="toolbar__menu__logo" [routerLink]="['/'] | localize">
      <img [src]="'company.logo.url' | translate" [alt]="'company.name' | translate" />
    </a>
    <div class="toolbar__menu__actions">
      <ul class="toolbar__menu__actions__languages">
        <li [class.active]="isCurrentLang(lang)" class="toolbar__menu__actions__languages__items" *ngFor="let lang of langs">
          <a (click)="setLang(lang)">{{ lang }}</a>
        </li>
      </ul>
      <div class="toolbar__menu__actions__quicklinks">
        <ng-container *ngFor="let item of 'nav.items' | translate">
          <a *ngIf="item.isQuickLink" class="toolbar__menu__quicklinks__item" placeme-fat-button [routerLink]="item.slug">
            <span>{{ item.label }}</span>
          </a>
        </ng-container>
      </div>
    </div>
  </div>
</header>

<nav class="menu" #menuRef>
  <ul class="menu__list" #menuListRef>
    <button
      class="menu__list__hamburger hamburger hamburger--elastic-r"
      [class.is-active]="isActiveMenu"
      type="button"
      aria-label="Menu"
      aria-controls="navigation"
      (click)="toggleMenu()"
    >
      <span class="hamburger-box">
        <span class="hamburger-inner"></span>
      </span>
    </button>
    <li class="menu__list__item" #menuItemRef *ngFor="let item of 'nav.items' | translate">
      <a [routerLink]="item.slug" [routerLinkActiveOptions]="{ exact: true }" (click)="toggleMenu()" routerLinkActive="active">
        {{ item.label }}
      </a>
    </li>
  </ul>
</nav>

<ng-content></ng-content>

<footer>
  <div class="container">
    <div class="informations">
      <ul>
        <li>{{ 'company.name' | translate }}</li>
        <li>Société au capital de {{ 'company.capital' | translate }}</li>
        <li>
          {{ 'company.address.street' | translate }}, {{ 'company.address.zipcode' | translate }} {{ 'company.address.city' | translate }}
        </li>
      </ul>
      <ul>
        <li>N° SIRET: {{ 'company.siret' | translate }}</li>
        <li>Code APE: {{ 'company.ape' | translate }}</li>
        <li>TVA: {{ 'company.vat' | translate }}</li>
      </ul>
    </div>
    <div class="medias">
      <a target="_blank" [href]="'social.linkedin' | translate" class="medias__item">
        <fa-icon [icon]="faLinkedinIn"></fa-icon>
      </a>
      <a target="_blank" [href]="'social.github' | translate" class="medias__item">
        <fa-icon [icon]="faGithub"></fa-icon>
      </a>
      <a target="_blank" [href]="'social.twitter' | translate" class="medias__item">
        <fa-icon [icon]="faTwitter"></fa-icon>
      </a>
      <a target="_blank" [href]="'social.instagram' | translate" class="medias__item">
        <fa-icon [icon]="faInstagram"></fa-icon>
      </a>
      <a target="_blank" [href]="'social.facebook' | translate" class="medias__item">
        <fa-icon [icon]="faFacebookF"></fa-icon>
      </a>
    </div>
  </div>
</footer>
